import { Tag, baseApi } from './base'

import { Account } from '@/core/models/account.model'

import { cacher } from '@/utils/rtkQueryCacheUtils'

export type ApiKey = Account & {
  createdBy: string
  name?: string
  prefix: string
}

export type CreateApiKeyParams = {
  name?: string
  policies?: string[]
}

export type UpdateApiKeyParams = Partial<CreateApiKeyParams> & { id: string }

export const apiKeyApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getApiKey: builder.query<ApiKey, string>({
      query: (apiKeyId) => ({
        url: `/api-keys/${apiKeyId}`,
        method: 'GET',
      }),
    }),
    getApiKeys: builder.query<ApiKey[], void>({
      query: () => ({
        url: `/api-keys`,
        method: 'GET',
      }),
      providesTags: cacher.providesList(Tag.API_KEY),
    }),
    createApiKey: builder.mutation<{ apiKey: string }, CreateApiKeyParams>({
      query: (body) => ({
        url: '/api-keys',
        method: 'POST',
        body,
      }),
      invalidatesTags: cacher.invalidatesList(Tag.API_KEY),
    }),
    updateApiKey: builder.mutation<ApiKey, UpdateApiKeyParams>({
      query: ({ id, ...body }) => ({
        url: `/api-keys/${id}`,
        method: 'PUT',
        body,
      }),
      async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedApiKey } = await queryFulfilled
          dispatch(
            apiKeyApi.util.updateQueryData('getApiKey', id, (draftApiKey) => {
              Object.assign(draftApiKey, updatedApiKey)
            })
          )
        } catch (error) {
          console.log(error)
        }
      },
    }),
    deleteApiKey: builder.mutation<ApiKey, string>({
      query: (policyId) => ({
        url: `/api-keys/${policyId}`,
        method: 'DELETE',
      }),
      invalidatesTags: cacher.invalidatesList(Tag.API_KEY),
    }),
  }),
  overrideExisting: false,
})
